/** In endpoint /v1/machines/view/SD-2 
 * last_status is machine status

MachineStatus - 1 (Running)
MachineStatus - 2(Stopped)
MachineStatus - 3 (error)
*/

export const ALL_MACHINE_STATUS = "1,2,3";

export type MachineStatus = "running" | "stopped" | "error" | string;

const machineStatusColorLookup: {
  [key: string]: "green" | "grey" | "red";
} = {
  1: "green",
  2: "grey",
  3: "red",
};

const machineStatusLookup: {
  [key: string]: "running" | "stopped" | "error";
} = {
  1: "running",
  2: "stopped",
  3: "error",
};

export const machineStatusIdToName = (id: string) => {
  return machineStatusLookup[id];
};

export const machineStatusIdToColor = (id: string) => {
  return machineStatusColorLookup[id];
};
